import RestService from './RestService';

export default class ACL extends RestService {
    constructor() {
        super('/acl');
    }

    findPrincipal(value) {
        return this.get(`${this.baseUrl}/principal`, { value });
    }

    getAclGroups() {
        return this.get(`${this.baseUrl}/groups`);
    }

    /**
     * Create a new ACL content group.
     * The backend is expected to accept at least { name } and optionally other metadata.
     */
    createGroup(data) {
        return this.post(`${this.baseUrl}/groups`, data);
    }

    /**
     * Update an existing ACL content group.
     */
    updateGroup(id, data) {
        return this.put(`${this.baseUrl}/groups/${encodeURIComponent(id)}`, data);
    }

    /**
     * Delete an ACL content group.
     */
    deleteGroup(id) {
        return this.del(`${this.baseUrl}/groups/${encodeURIComponent(id)}`);
    }

    /**
     * List members of a content group (stored separately from ACL rules).
     */
    getGroupMembers(groupId) {
        return this.get(`${this.baseUrl}/groups/${encodeURIComponent(groupId)}/members`);
    }

    /**
     * Add a member (partner/company) to a content group.
     */
    addGroupMember(groupId, principalUniqueId) {
        return this.post(`${this.baseUrl}/groups/${encodeURIComponent(groupId)}/members`, {
            principal_unique_id: principalUniqueId,
        });
    }

    /**
     * Remove a member from a content group.
     */
    removeGroupMember(groupId, principalUniqueId) {
        return this.del(
            `${this.baseUrl}/groups/${encodeURIComponent(groupId)}/members/${encodeURIComponent(principalUniqueId)}`
        );
    }

    /**
     * Bulk set content access rules for a principal (group).
     * rule: 1 = allow, 0 = deny. Single request; server supports array of object_unique_ids.
     */
    setContentAccessBulk(principalUniqueId, objectUniqueIds, rule) {
        return this.post(`${this.baseUrl}/bulk`, {
            principal_unique_id: principalUniqueId,
            object_unique_ids: objectUniqueIds,
            rule,
        });
    }

    /**
     * Bulk remove content access rules (reset to default). Single request.
     */
    removeContentAccessBulk(principalUniqueId, objectUniqueIds) {
        return this.del(`${this.baseUrl}/bulk`, {
            principal_unique_id: principalUniqueId,
            object_unique_ids: objectUniqueIds,
        });
    }

    findAclRulesForPrincipal(principal) {
        return this.list({ principal });
    }
}
